/* Ordinia · productos digitales: pestañas con animación, acordeón y entrada de cabecera.
   Sin dependencias. Sin JavaScript todo se ve apilado y legible. */
(function () {
  'use strict';
  var roots = document.querySelectorAll('[data-od]');
  Array.prototype.forEach.call(roots, init);

  function init(root) {
    if (root.__od) return;
    root.__od = true;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-od-tab]'));
    var panels = {};
    Array.prototype.forEach.call(root.querySelectorAll('[data-od-panel]'), function (p) { panels[p.getAttribute('data-od-panel')] = p; });
    var stage = root.querySelector('[data-od-stage]');
    var thumb = root.querySelector('.od-thumb');
    var order = tabs.map(function (t) { return t.getAttribute('data-od-tab'); });
    var current = order[0];
    var busy = false;
    var pending = null;

    root.classList.add('od-js');

    // Etiquetas de la cabecera escalonadas
    Array.prototype.forEach.call(root.querySelectorAll('.od-chip--hero'), function (c, i) { c.style.setProperty('--n', i); });

    function wait(ms) { return new Promise(function (r) { window.setTimeout(r, ms); }); }
    function stagger(panel) {
      var i = 0;
      Array.prototype.forEach.call(panel.querySelectorAll('[data-od-s]'), function (el) { el.style.setProperty('--i', i++); });
    }
    function moveThumb(animate) {
      var active = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0];
      if (!active || !thumb) return;
      if (!animate) thumb.style.transition = 'none';
      thumb.style.setProperty('--x', active.offsetLeft + 'px');
      thumb.style.setProperty('--w', active.offsetWidth + 'px');
      if (!animate) { void thumb.offsetWidth; thumb.style.transition = ''; }
      // Mantiene a la vista la pestaña activa en móvil
      if (active.scrollIntoView && root.querySelector('.od-tabs').scrollWidth > root.querySelector('.od-tabs').clientWidth) {
        try { active.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); } catch (e) {}
      }
    }
    // Órbita grande: el punto viaja a la sección activa y el arco se completa (en la última forma el logo)
    var orbit = root.querySelector('[data-od-orbit]');
    var orbitDot = orbit && orbit.querySelector('.od-orbit-lg__dot');
    var orbitArc = orbit && orbit.querySelector('.od-orbit-lg__arc');
    var orbitN = orbit && orbit.querySelector('[data-od-n]');
    var orbitName = orbit && orbit.querySelector('[data-od-name]');
    var angle = 0, idxNow = 0;
    function setOrbit(idx, animate) {
      if (!orbit) return;
      var n = order.length;
      var delta = ((idx - idxNow) % n + n) % n;
      if (delta > n / 2) delta -= n;
      angle += delta * (360 / n);
      idxNow = idx;
      if (!animate) { orbitDot.style.transition = 'none'; orbitArc.style.transition = 'none'; }
      orbitDot.style.setProperty('--a', angle);
      orbitArc.style.strokeDashoffset = String(100 - (100 / n) * idx);
      if (!animate) { void orbit.offsetWidth; orbitDot.style.transition = ''; orbitArc.style.transition = ''; }
      if (orbitN) orbitN.textContent = '0' + (idx + 1) + ' / 0' + n;
      var lastNode = tabs[idx].lastChild;
      var label = (lastNode ? lastNode.textContent : tabs[idx].textContent).trim();
      if (!orbitName || orbitName.textContent === label) return;
      if (!animate) { orbitName.textContent = label; return; }
      orbitName.classList.remove('od-roll-in'); orbitName.classList.add('od-roll-out');
      window.setTimeout(function () { orbitName.textContent = label; orbitName.classList.remove('od-roll-out'); orbitName.classList.add('od-roll-in'); }, 200);
    }
    // Porcentaje de la captura: cuenta hasta su valor al entrar el catálogo
    function countUp(panel) {
      var el = panel.querySelector('[data-od-count]');
      if (!el) return;
      var target = parseInt(el.getAttribute('data-od-count'), 10) || 0, t0 = null, delay = 500, dur = 1400;
      el.textContent = '0 %';
      function frame(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, Math.max(0, (ts - t0 - delay) / dur));
        el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3))) + ' %';
        if (p < 1) window.requestAnimationFrame(frame);
      }
      window.requestAnimationFrame(frame);
    }
    // Intro tipo arranque: escribe unas líneas y deja paso a la página. Se salta con un clic o una tecla.
    function runBoot() {
      var h = document.documentElement;
      var el = document.querySelector('[data-od-boot]');
      var log = el && el.querySelector('[data-od-log]');
      if (!el || !log || !h.classList.contains('od-boot-on')) return Promise.resolve();
      return new Promise(function (resolve) {
        var finished = false, timers = [];
        function later(fn, ms) { timers.push(window.setTimeout(fn, ms)); }
        function finish() {
          if (finished) return; finished = true;
          timers.forEach(window.clearTimeout);
          document.removeEventListener('keydown', finish); el.removeEventListener('click', finish);
          h.classList.remove('od-boot-hold');
          el.classList.add('is-out');
          resolve();
          window.setTimeout(function () { h.classList.remove('od-boot-on'); el.classList.remove('is-out'); }, 520);
        }
        document.addEventListener('keydown', finish); el.addEventListener('click', finish);
        var cursor = document.createElement('span'); cursor.className = 'od-boot__cur';
        var lines = [
          { p: 'ordinia@digital:~$ ', t: 'abrir productos-digitales', s: 24 },
          { p: '', t: '> comprobando catálogo ........ ok', s: 8 },
          { p: '', t: '> cargando herramientas ...... ok', s: 8 },
          { p: '', t: '> listo', s: 30 }
        ];
        var at = 120;
        lines.forEach(function (ln) {
          var row = document.createElement('div'); log.appendChild(row);
          if (ln.p) { var b = document.createElement('b'); b.textContent = ln.p; row.appendChild(b); }
          var txt = document.createTextNode(''); row.appendChild(txt);
          later(function () { row.appendChild(cursor); }, at);
          for (var i = 1; i <= ln.t.length; i++) { (function (n) { later(function () { txt.nodeValue = ln.t.slice(0, n); }, at + n * ln.s); })(i); }
          at += ln.t.length * ln.s + 170;
        });
        later(finish, at + 260);
      });
    }
    var bootDone = runBoot();
    function enter(panel) {
      var hold = panel.querySelector('.od-console') ? 3200 : 2000;
      panel.classList.add('od-enter', 'od-seen');
      countUp(panel);
      window.clearTimeout(panel.__odT);
      panel.__odT = window.setTimeout(function () { panel.classList.remove('od-enter'); }, hold);
    }
    function select(name) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-od-tab') === name;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
      });
    }

    function show(name, opts) {
      opts = opts || {};
      if (!panels[name]) return Promise.resolve();
      if (busy) { pending = name; return Promise.resolve(); }
      if (name === current && !opts.first) return Promise.resolve();
      var from = panels[current];
      var to = panels[name];
      var dir = order.indexOf(name) >= order.indexOf(current) ? 1 : -1;
      select(name);
      setOrbit(order.indexOf(name), !opts.first);
      moveThumb(!opts.first);

      if (opts.first) {
        Object.keys(panels).forEach(function (k) { panels[k].hidden = k !== name; panels[k].classList.remove('od-enter', 'od-leave'); });
        to.style.setProperty('--dx', '0px');
        stagger(to);
        current = name;
        bootDone.then(function () { enter(to); });
        return Promise.resolve();
      }

      busy = true;
      var h0 = from.offsetHeight;
      stage.style.height = h0 + 'px';
      from.style.setProperty('--dx', (dir * 28) + 'px');
      from.classList.add('od-leave');
      return wait(190).then(function () {
        from.hidden = true;
        from.classList.remove('od-leave');
        to.hidden = false;
        to.style.setProperty('--dx', (dir * 28) + 'px');
        stagger(to);
        enter(to);
        stage.style.height = to.offsetHeight + 'px';
        current = name;
        return wait(Math.max(560, to.querySelectorAll('[data-od-s]').length * 70 + 700));
      }).then(function () {
        stage.style.height = '';
        busy = false;
        if (pending && pending !== current) { var n = pending; pending = null; return show(n); }
        pending = null;
      });
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        var n = t.getAttribute('data-od-tab');
        show(n);
        try { history.replaceState(null, '', '#' + n); } catch (e) {}
      });
      t.addEventListener('keydown', function (e) {
        var k = e.key, j = -1;
        if (k === 'ArrowRight') j = (i + 1) % tabs.length;
        else if (k === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length;
        else if (k === 'Home') j = 0;
        else if (k === 'End') j = tabs.length - 1;
        if (j < 0) return;
        e.preventDefault();
        tabs[j].focus();
        tabs[j].click();
      });
    });

    // Acordeón de preguntas
    Array.prototype.forEach.call(root.querySelectorAll('.od-faq__q'), function (q) {
      var body = document.getElementById(q.getAttribute('aria-controls'));
      if (body) body.setAttribute('inert', '');
      q.addEventListener('click', function () {
        var open = q.getAttribute('aria-expanded') === 'true';
        q.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (body) { if (open) body.setAttribute('inert', ''); else body.removeAttribute('inert'); }
      });
    });

    // Atajos: 1 a 4 cambian de sección
    document.addEventListener('keydown', function (e) {
      if (e.metaKey || e.ctrlKey || e.altKey || e.defaultPrevented) return;
      var tg = e.target;
      if (tg && (/^(input|textarea|select)$/i.test(tg.tagName) || tg.isContentEditable)) return;
      var i = '1234'.indexOf(e.key);
      if (e.key.length === 1 && i > -1 && tabs[i]) tabs[i].click();
    });

    // Reajusta la pastilla al cambiar el tamaño o cargar la tipografía
    var rt = null;
    window.addEventListener('resize', function () { window.clearTimeout(rt); rt = window.setTimeout(function () { moveThumb(false); }, 80); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { moveThumb(false); });

    // Arranque: respeta #enlace (por ejemplo, ...#preguntas)
    var hash = (location.hash || '').replace('#', '');
    var start = panels[hash] ? hash : order[0];
    current = start;
    show(start, { first: true });
    moveThumb(false);
  }
})();
